import React from "react";

// Swallows errors from a 3D scene (ex: WebGL unavailable) so the page keeps its static artwork instead of crashing.
class SceneBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch() {
    if (this.props.onError) this.props.onError();
  }

  render() {
    if (this.state.failed) return null;
    return this.props.children;
  }
}

export default SceneBoundary;
